module.exports = __webpack_public_path__ + "static/media/saobang.5319695a.png";